export default [
  {
    path: '/partners',
    name: 'Partners-list',
    component: () => import('@/components/adm/partners/PartnersList.vue'),
    meta: {
      title: "Cadastro > Controladores"
    }
  }
]